import { Link } from 'react-router-dom';

export default function TermsOfService() {
    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-3xl mx-auto px-6 py-16">
                <div className="mb-8">
                    <Link to="/" className="text-sm text-blue-600 hover:text-blue-700">
                        ← Back to CourseMap
                    </Link>
                </div>

                <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
                <p className="text-sm text-gray-400 mb-10">Last updated: Mar 28, 2026</p>

                <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
                    <p>By accessing or using CourseMap, you agree to these Terms of Service.</p>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Use of Service</h2>
                        <p className="mb-2">CourseMap provides tools to help users explore academic requirements and plan courses.</p>
                        <p>You agree to use the service only for lawful purposes and not to misuse or interfere with the platform.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Accounts</h2>
                        <p>You must sign in using a valid Google account. You are responsible for maintaining the security of your account.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">3. User-Provided Information</h2>
                        <p>You are responsible for the accuracy of the information you input into the platform.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Disclaimer of Academic Accuracy</h2>
                        <p className="mb-2">CourseMap provides course planning tools for informational purposes only.</p>
                        <p className="mb-2">We do not guarantee the accuracy, completeness, or reliability of any academic information.</p>
                        <p className="mb-2">Users are solely responsible for ensuring that their course selections meet the requirements of their institution.</p>
                        <p>Official university websites and academic advisors should always be considered the authoritative source.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">5. No Professional Advice</h2>
                        <p>The information provided by CourseMap does not constitute academic advising or professional guidance.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Availability</h2>
                        <p>We do not guarantee that the service will always be available or error-free.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Termination</h2>
                        <p>We may suspend or terminate access to the service at any time without notice.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Disclaimer of Warranties</h2>
                        <p>The service is provided "as is" and "as available" without warranties of any kind.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">9. Limitation of Liability</h2>
                        <p>To the maximum extent permitted by law, CourseMap shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">10. Governing Law</h2>
                        <p>These Terms are governed by the laws of the State of New York, United States.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">11. Changes to Terms</h2>
                        <p>We may update these Terms from time to time. Continued use of the service constitutes acceptance of the updated Terms.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">12. Contact</h2>
                        <p>If you have any questions, please contact us at: <a href="mailto:admin@coursemap.app" className="text-blue-600 hover:underline">admin@coursemap.app</a></p>
                    </section>
                </div>
            </div>
        </div>
    );
}
